const ANALYTICS_CONSENT_KEY = 'jacana.analyticsConsent';

export function getAnalyticsConsentStatus() {
  if (typeof window === 'undefined') {
    return 'unset';
  }

  const value = window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
  if (value === 'accepted' || value === 'rejected') {
    return value;
  }

  return 'unset';
}

export function setAnalyticsConsentStatus(status) {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(ANALYTICS_CONSENT_KEY, status);
}

export function canUseAnalytics() {
  return getAnalyticsConsentStatus() === 'accepted';
}